/**
 * SVG shapes extracted from oliverlist sidebar HTML mocks (refonte / booker / client).
 * viewBox 0 0 24 24, stroke icons — rendered by SidebarIcon.vue
 */

export const SIDEBAR_ICONS = {
  activity: [
    { type: "path", attrs: { d: "M3 12h4l2 6 4-14 2 8h6" } },
  ],
  opportunities: [
    {
      type: "path",
      attrs: {
        d: "M3 11a9 9 0 0118 0v5a2 2 0 01-2 2h-2v-6h4M3 11v5a2 2 0 002 2h2v-6H3",
      },
    },
  ],
  orders: [
    { type: "path", attrs: { d: "M4 5v14M8 5v14M12 5v14M16 5v14M20 5v14" } },
  ],
  copywriting: [
    {
      type: "path",
      attrs: {
        d: "M21 15a4 4 0 01-4 4H8l-5 3V7a4 4 0 014-4h10a4 4 0 014 4z",
      },
    },
  ],
  "master-inbox": [
    { type: "path", attrs: { d: "M4 5h16v14H4zM4 8l8 5 8-5" } },
  ],
  calendar: [
    {
      type: "rect",
      attrs: { x: "3", y: "4", width: "18", height: "17", rx: "2" },
    },
    { type: "path", attrs: { d: "M16 2v4M8 2v4M3 10h18" } },
  ],
  contacts: [
    { type: "circle", attrs: { cx: "9", cy: "8", r: "3" } },
    {
      type: "path",
      attrs: { d: "M3 20a6 6 0 0112 0M16 3.5a3 3 0 010 7M21 20a6 6 0 00-4-5.6" },
    },
  ],
  "attendance-group": [
    { type: "circle", attrs: { cx: "9", cy: "8", r: "3.2" } },
    { type: "path", attrs: { d: "M3 20a6 6 0 0112 0M17 11l2 2 4-4" } },
  ],
  play: [
    { type: "polygon", attrs: { points: "6 4 20 12 6 20 6 4" } },
  ],
  infrastructure: [
    {
      type: "rect",
      attrs: { x: "3", y: "4", width: "18", height: "6", rx: "1.5" },
    },
    {
      type: "rect",
      attrs: { x: "3", y: "14", width: "18", height: "6", rx: "1.5" },
    },
    { type: "path", attrs: { d: "M7 7h.01M7 17h.01" } },
  ],
  configuration: [
    { type: "circle", attrs: { cx: "11", cy: "11", r: "7" } },
    { type: "path", attrs: { d: "M21 21l-4-4" } },
  ],
  bookers: [
    { type: "path", attrs: { d: "M3 11l5 5 4-4 3 3 6-7" } },
    { type: "path", attrs: { d: "M3 17h18" } },
  ],
  "users-single": [
    { type: "circle", attrs: { cx: "12", cy: "8", r: "4" } },
    { type: "path", attrs: { d: "M4 21a8 8 0 0116 0" } },
  ],
  clients: [
    {
      type: "rect",
      attrs: { x: "3", y: "7", width: "18", height: "13", rx: "2" },
    },
    {
      type: "path",
      attrs: { d: "M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2" },
    },
  ],
  "account-management": [
    { type: "circle", attrs: { cx: "9", cy: "8", r: "3.2" } },
    {
      type: "path",
      attrs: { d: "M3 20a6 6 0 0112 0M16 4a3 3 0 010 6M21 20a6 6 0 00-4-5.6" },
    },
  ],
  revenue: [
    {
      type: "rect",
      attrs: { x: "3", y: "6", width: "18", height: "12", rx: "2" },
    },
    { type: "circle", attrs: { cx: "12", cy: "12", r: "2.5" } },
  ],
  affiliates: [
    { type: "path", attrs: { d: "M4 7h16M4 12h16M4 17h12" } },
  ],
  claims: [
    { type: "circle", attrs: { cx: "12", cy: "12", r: "9" } },
    { type: "path", attrs: { d: "M12 8v5M12 16h.01" } },
  ],
  reports: [
    { type: "circle", attrs: { cx: "12", cy: "12", r: "9" } },
    { type: "path", attrs: { d: "M12 12l4-3" } },
  ],
  settings: [
    { type: "circle", attrs: { cx: "12", cy: "12", r: "3" } },
    {
      type: "path",
      attrs: {
        d: "M19.4 13a7.5 7.5 0 000-2l2-1.5-2-3.4-2.3 1a7 7 0 00-1.7-1L17 3H7l-.4 2.6a7 7 0 00-1.7 1l-2.3-1-2 3.4 2 1.5a7.5 7.5 0 000 2l-2 1.5 2 3.4 2.3-1a7 7 0 001.7 1L7 21h10l.4-2.6a7 7 0 001.7-1l2.3 1 2-3.4z",
      },
    },
  ],
  logout: [
    {
      type: "path",
      attrs: {
        d: "M16 17l5-5-5-5M21 12H9M12 3H6a2 2 0 00-2 2v14a2 2 0 002 2h6",
      },
    },
  ],
  onboarding: [
    { type: "path", attrs: { d: "M8 11l4 4 8-8M3 13l4 4" } },
  ],
  "lead-room": [
    { type: "path", attrs: { d: "M3 11l11-6v14L3 13zM14 8a4 4 0 010 8" } },
  ],
  resources: [
    { type: "path", attrs: { d: "M3 7l9-4 9 4-9 4-9-4z" } },
    {
      type: "path",
      attrs: { d: "M7 10v5c0 1 2.5 2 5 2s5-1 5-2v-5" },
    },
  ],
  ranking: [
    { type: "circle", attrs: { cx: "12", cy: "9", r: "5" } },
    { type: "path", attrs: { d: "M9 13l-2 8 5-3 5 3-2-8" } },
  ],
  "attendance-monitor": [
    {
      type: "rect",
      attrs: { x: "3", y: "5", width: "18", height: "12", rx: "2" },
    },
    { type: "path", attrs: { d: "M8 21h8M12 17v4" } },
  ],
  help: [
    { type: "circle", attrs: { cx: "12", cy: "12", r: "9" } },
    {
      type: "path",
      attrs: {
        d: "M9.5 9a2.5 2.5 0 015 0c0 1.5-2.5 2-2.5 3.5M12 17h.01",
      },
    },
  ],
  "users-team": [
    { type: "circle", attrs: { cx: "12", cy: "6", r: "2.5" } },
    {
      type: "path",
      attrs: {
        d: "M9 11h6M12 8.5V11M7 17v-2a2 2 0 012-2h6a2 2 0 012 2v2",
      },
    },
    { type: "circle", attrs: { cx: "7", cy: "18", r: "2" } },
    { type: "circle", attrs: { cx: "17", cy: "18", r: "2" } },
  ],
  playbook: [
    { type: "circle", attrs: { cx: "12", cy: "12", r: "9" } },
    { type: "path", attrs: { d: "M12 11v5M12 8h.01" } },
  ],
  blacklist: [
    { type: "circle", attrs: { cx: "12", cy: "12", r: "9" } },
    { type: "path", attrs: { d: "M5.6 5.6l12.8 12.8" } },
  ],
};

const ADMIN_MENU_ID_ICONS = {
  orders: "orders",
  targetNoteChat: "copywriting",
  attendance: "attendance-group",
  infrastructure: "infrastructure",
  configuration: "configuration",
  bdr: "bookers",
  clients: "clients",
  sale_dashboard: "account-management",
  revenue: "revenue",
  claims: "claims",
  reports: "reports",
};

const ADMIN_LINK_ICONS = {
  "/activity": "activity",
  "/opportunities": "opportunities",
  "/emails": "master-inbox",
  "/calendars": "calendar",
  "/businesses": "contacts",
  "/ai-meetings-replay": "play",
  "/users": "users-single",
  "/Affiliation": "affiliates",
};

const CLIENT_LINK_ICONS = {
  "/dashboard": "reports",
  "/activity": "activity",
  "/orders": "orders",
  "/businesses": "contacts",
  "/my_team": "users-team",
  "/ai-meetings-replay": "play",
  "/playbook": "playbook",
  "/calendar_config": "calendar",
  "/blacklist": "blacklist",
};

export function resolveAdminSidebarIcon(entry) {
  if (!entry) {
    return null;
  }
  if (entry.type === "settings") {
    return "settings";
  }
  if (entry.menuId && ADMIN_MENU_ID_ICONS[entry.menuId]) {
    return ADMIN_MENU_ID_ICONS[entry.menuId];
  }
  if (entry.linkTo && ADMIN_LINK_ICONS[entry.linkTo]) {
    return ADMIN_LINK_ICONS[entry.linkTo];
  }
  return null;
}

export function resolveClientSidebarIcon(entry) {
  if (!entry) {
    return null;
  }
  if (entry.type === "onboarding") {
    return "onboarding";
  }
  if (entry.linkTo && CLIENT_LINK_ICONS[entry.linkTo]) {
    return CLIENT_LINK_ICONS[entry.linkTo];
  }
  return null;
}

export function resolveAdminOrphanSidebarIcon(link) {
  if (!link || !link.linkTo) {
    return null;
  }
  return ADMIN_LINK_ICONS[link.linkTo] || null;
}
